document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  document.querySelectorAll('header-menu details').forEach((details) => {
    let closeTimer;

    const open = () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    };

    const close = () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => details.removeAttribute('open'), 120);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);

    // voorkom "klik toggle" op desktop
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (isDesktop()) e.preventDefault();
      });
    }
  });
});
